import _ from 'lodash';

class PaperlessbillingController {
    constructor($timeout, $scope, navigationManager, mockService, authService, billingService,$filter,storage,$state,
                $rootScope, $interval, $window, analyticsService) {
        this.$timeout = $timeout;
        this.state = $state;
        this.$rootScope = $rootScope;
        this.name = 'Go Paperless';
        this.analyticsService = analyticsService;

        /*console.log("AM or PM:", $filter('date')(now, 'a'));*/

        //this.currunttime = this._getTime();
        this.enrollmsgString = "By enrolling in paperless billing, you will no longer receive paper statements in the mail.";
        this.msgString = "Instead, we'll send you an email and let you know when your statement is available for viewing online.";
        //this.paymentSuccessString = "This is the most current information available to both our systems and customer service agents. It includes all credits and payments processed up through " + this.currunttime + ", today.";
        this.lastPaymentDate = '';
        this.paymentAlertMsg = 'ERROR!';

        this.$scope = $scope;

        console.log('checking paperlessbill : ' +this.$rootScope.omniturePaperlessbill +'billing Status : ' +this.$rootScope.omnitureBillingStatus);
        // omniture on view pay bill
        $scope.linkURL = null;
        $scope.event = null;
        $scope.pageName = null;
        $scope.linkName = null;
        $scope.omnitureBillingStatus = this.$rootScope.omnitureBillingStatus;
        $scope.omniturePaperlessbill = this.$rootScope.omniturePaperlessbill;

        //!! omniture when paperless loads
        console.log('!!omniture when paperless loads');
        analyticsService.sendReport('go paperless', 'enroll review', 'event1', null, null, null, null, null, 
          $scope.omnitureBillingStatus, $scope.omniturePaperlessbill);

        $scope.$watch('[event, pageName, linkName, linkURL]', function (newValue, oldValue) {
          console.log('!! omniture watch variables from paperlessbilling, event : ' +$scope.event +' pageName : ' +$scope.pageName +' linkName : '
            +$scope.linkName +' linkURL : ' +$scope.linkURL);
          if($scope.pageName) {
            console.log('inside if paperlessbilling watch variables');
            analyticsService.sendReport('go paperless', $scope.pageName, $scope.event, $scope.omnitureErrorMsg, null, null,
              $scope.linkName, $scope.linkURL, $scope.omnitureBillingStatus, $scope.omniturePaperlessbill);
          }
        });


        /*************************************************************************/
        /*   The below block is to set the flags on the basis of bpglobal call    */
        /*************************************************************************/

        /* */
        this.displayModalContent = true;
        this.bpGlobalDataLoader = true;

        //this is for alert box
        this.displayAlertModal = false;
        this.alertMsgTwo = '';
        this.alertMsgOne='';
        this.alertMsgTitle='';
        this.isTechFailureAlert=false;
        this.isRoutingOne = false;
        this.isValidDecline = false;
        this.isInvalidCC = false;
        this.isInvalidCCExDate = false;
        this.onlyOnePaymentMethodAfterError = false;
        this.multiVersionDeauth = false;

        //scheduling
        this.schedulePayment = null;

        //bpglobal with or without optimumid
        this.hasOptimumId=false;

        /*************************************************************************/
        /*   The below block is for the paperless billing                        */
        /*************************************************************************/

        //variables
        this.paperlessLoader = true;
        this.email = null;
        this.emailButNotEnrolled  = false;
        this.emailAndEnrolled  = false;
        this.noEmail= false;
        this.hasOptimumId=true;
        this.errorFetchingInfo = false;


        /*************************************************************************/
        /*   The below block is to set the flagson the basis of bpglobal call    */
        /*************************************************************************/

        navigationManager.registerViewComponent(this, $scope, 'home.paperlessbilling');

        this.keyWatch = event => {
          const eventTarget = document.getElementById('paperlessbillingcontainer');
          eventTarget.addEventListener('keydown', this.keydown);
        };

        this.keydown = (event)=> {
          if(!this.displayAlertModal){
            if(event.keyCode === 27 || event.keyCode === 8 || event.keyCode ===461){
                document.getElementById('paperlessbillingcontainer').removeEventListener('keydown', this.keydown);
                this.$rootScope.fromPaperlessBillingPage = true;
                this.state.go('home.landingpage');
            }
          } else {
            console.log("Back button should not work");
          }
        };


        billingService.getCurrectAcc().then((res)=>{
          //When you don't have optimum id
          //console.log('Res for account on paperless :',res);
          //console.log('Res for primary optimum id :',storage.getItem('session','hasOptimumId'));

          if(!storage.getItem('session','hasOptimumId')){
            //this.hasOptimumId=false;
            //this.landingPagePaperlessLoader = false;
          }
          else if(res && !res.email){
            this.noEmail = true;
            this.paperlessLoader = false;
            this.focusItem('add-enroll-btn');

            setTimeout(function() {
              //navigation setup
              navigationManager.registerNavigate('add-enroll-btn', 'down');
              navigationManager.registerNavigate('add-enroll-btn', 'left');
              navigationManager.registerNavigate('add-enroll-btn', 'up');
              navigationManager.registerNavigate('add-enroll-btn', 'right');
            }, 500);

          }
          else if(res && res.email && res.isPaperBill === "true"){
            this.emailButNotEnrolled  = true;

            storage.setItem('session','userEmail',res.email);
            var preEmail = res.email;
            var index = preEmail.indexOf("@");  
            var name = preEmail.substr(0, index); // Gets the first part
            var nameLength = name.length;
            console.log("name is " + name);
            var domain = preEmail.substr(index + 1);  // Gets the second part
            var domainLength = domain.length;
            var totalchar = domainLength + nameLength;
            console.log("domain is " + domain);

            if (totalchar <= 36) {
              this.email = res.email;
              console.log ("totalchar <= 36 and email is " + this.email);
            } else if (nameLength > 18 && domainLength > 18) {
              this.email = name.substring(0,16) + "...@" + domain.substring(0,16) + "...";
              console.log ("both large and email is " + this.email);
            } else if (nameLength > 18 && domainLength <= 18) {
              var newnameLength = 34 - domainLength;
              this.email = name.substring(0,newnameLength) + "...@" + domain;
              console.log ("name large and email is " + this.email);
            } else if (nameLength <= 18 && domainLength > 18) {
              var newdomainLength = 34 - nameLength;
              this.email = name.substring(0,nameLength) + "@" + domain.substring(0,newdomainLength) + "...";
              console.log ("domain large and email is " + this.email);
            } else {
              this.email = res.email;
              console.log ("no large and email is " + this.email);
            }
            this.paperBillInd = res.isPaperBill;
            this.paperlessLoader = false;
            this.focusItem('enroll-btn');
            setTimeout(function() {
                    //navigation setup
                navigationManager.registerNavigate('enroll-btn', 'down');
                navigationManager.registerNavigate('enroll-btn', 'left', 'update-enroll-btn');
                navigationManager.registerNavigate('enroll-btn', 'up');
                navigationManager.registerNavigate('enroll-btn', 'right');

                navigationManager.registerNavigate('update-enroll-btn', 'down');
                navigationManager.registerNavigate('update-enroll-btn', 'right', 'enroll-btn');
                navigationManager.registerNavigate('update-enroll-btn', 'up');
                navigationManager.registerNavigate('update-enroll-btn', 'left');
                var emailElement = document.getElementsByClassName("amountdue");
                var emailWidth = emailElement[0].offsetWidth;
            }, 500);

          }
          else if(res && res.email && res.isPaperBill === "false"){
            //this.emailAndEnrolled = true;
            //storage.setItem('session','userEmail',res.email);
            //this.email = res.email;
          }
          else{
            //this.errorFetchingInfo = true;
            //this.landingPagePaperlessLoader = false;
            this.paperlessLoader = false;
            this.$rootScope.fromPaperlessBillingPage = true;
            this.state.go('home.landingpage');
          }
        });


        this.paymentModalHandler = item => {
            this.displayPaymentModal = true;
            this.displayModalContent = true;
            console.log("item:", item);
            this.paymentMethodUsed = item.payment_method;
            setTimeout(function() {
                document.getElementById('confirm-btn').focus();
            }, 100);
        };

        this.enroll = _ => {
          // omniture when enroll now
          console.log('!!omniture when enroll now!!');
          $scope.pageName = 'enroll review';
          $scope.linkName = 'Enroll Now';
          $scope.linkURL = this.$rootScope.analytics.omniturePath +'/landingpage/paperlessbilling';

          var emailVal = this.email;

          console.log("Email to be enrolled:", emailVal);
          this.displayAlertModal = true;

          this.displayModalContent = false;
          this.loading = true;
          billingService.enrollPaperlessBill(false, emailVal).then(res => {
            console.log("Result in enroll api:", res);
            if(res.data.responseInfo && res.data.responseInfo.statusCode === "00000"){
              this.loading=false;
              this.$rootScope.enrollValue = true;

              //omniture paperless enrollment success
              console.log('!!omniture paperless enrollment success');
              this.$rootScope.paperlessbilling = true;
              this.$rootScope.fromPaperlessBillingPage = true;
              this.analyticsService.sendReport('go paperless', 'paperless enrollment success', 'event7', null, null, null, null, null,
                this.$rootScope.omnitureBillingStatus, true, this.$rootScope.analytics.omniturePath +'/landingpage');

              this.state.go('home.landingpage', {}, { reload: true });
            } else {
              this.loading=false;
              this.displayModalContent = true;
              // omniture when enroll error
              console.log('!!omniture when enrolled error!!');
              $scope.pageName = 'enroll error';

              setTimeout(function() {
                document.getElementById('alert-confirm-btn').focus();
                //this.focusItem('alert-confirm-btn');
              }, 150);
            }
          });
        };

        this.updateEmail = _ => {
          console.log('coming in update email');
          //omniture update email and enroll
          this.analyticsService.sendReport('go paperless', 'enroll review', $scope.event, $scope.omnitureErrorMsg, null, null, 'Update Email and Enroll', 
            this.$rootScope.analytics.omniturePath +'/keyboard', $scope.omnitureBillingStatus, $scope.omniturePaperlessbill, 
            this.$rootScope.analytics.omniturePath +'/paperlessbilling');

          this.state.go('home.keyboard');
        };

        this.alertDone = _ => {
          this.displayAlertModal = false;
          this.displayModalContent = false;
          setTimeout(function() {
            document.getElementById('enroll-btn').focus();
          }, 150);
        };

    }

    focusItem(id) {
      const el = document.getElementById(id);
      if (el) {
        console.log('got it',el);
        el.focus();
      } else {
        console.log('I am here in non-focus state.');
        this.$timeout(this.focusItem.bind(this,id));
      }
    }
}


PaperlessbillingController.$inject = ['$timeout', '$scope', 'navigationManager', 'mockService', 'authService',
  'billingService','$filter','storage','$state', '$rootScope', '$interval', '$window', 'analyticsService'];

export default PaperlessbillingController;



// WEBPACK FOOTER //
// ./client/app/components/paperlessbilling/paperlessbilling.controller.js